import { db } from './idb';

export type DocKey = 'photo' | 'dl' | 'aadhaar' | 'pan';

export type CachedDoc = {
  doc: DocKey;
  mime: string;
  blob: Blob;
  cachedAt: number;
};

export async function getCachedDoc(doc: DocKey): Promise<CachedDoc | null> {
  const handle = await db();
  const row = await handle.get('kycDocs', doc);
  return row ?? null;
}

export async function putCachedDoc(
  doc: DocKey,
  mime: string,
  blob: Blob,
  cachedAt: number = Date.now(),
): Promise<void> {
  const handle = await db();
  await handle.put('kycDocs', { doc, mime, blob, cachedAt });
}

export async function invalidateDoc(doc: DocKey): Promise<void> {
  const handle = await db();
  await handle.delete('kycDocs', doc);
}

export async function invalidateAllDocs(): Promise<void> {
  const handle = await db();
  await handle.clear('kycDocs');
}
